import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget =
  | 'first_time_lister_education_see_tips'
  | 'first_time_lister_education_show_help_center'
  | 'first_time_lister_education_close'
  | 'phishing_reminder_dialog_close'
  | 'phishing_reminder_dialog_learn_more'

type FirstTimeListerEducationPageLeaveEventArgs = {
  pageNumber: number
  goingToPageNumber: number | null
  timeSpentOnPageMs: number
  initialPageScrollDepth: number
  pageScrollDepth: number
}

type FirstTimeListerEducationPageLeaveEventExtra = {
  page_number: number
  going_to_page_number: number | null
  time_spent_on_page_ms: number
  initial_page_scroll_depth: number
  page_scroll_depth: number
  screen: string
}

export const firstTimeListerEducationPageLeaveEvent = (
  args: FirstTimeListerEducationPageLeaveEventArgs,
) => {
  const extra: FirstTimeListerEducationPageLeaveEventExtra = {
    page_number: args.pageNumber,
    going_to_page_number: args.goingToPageNumber,
    time_spent_on_page_ms: args.timeSpentOnPageMs,
    initial_page_scroll_depth: args.initialPageScrollDepth,
    page_scroll_depth: args.pageScrollDepth,
    screen: 'first_time_lister_education',
  }

  return {
    event: 'user.first_time_lister_education_page_leave',
    extra,
  }
}

type FirstTimeListerEducationExampleSwitchEventArgs = {
  pageNumber: number
  exampleNumber: number
  goingToExampleNumber: number
  timeSpentOnExampleMs: number
  automaticTransitionTimeMs: number
}

type FirstTimeListerEducationExampleSwitchEventExtra = {
  page_number: number
  example_number: number
  going_to_example_number: number
  time_spent_on_example_ms: number
  automatic_transition_time_ms: number
  screen: string
}

export const firstTimeListerEducationExampleSwitchEvent = (
  args: FirstTimeListerEducationExampleSwitchEventArgs,
) => {
  const extra: FirstTimeListerEducationExampleSwitchEventExtra = {
    page_number: args.pageNumber,
    example_number: args.exampleNumber,
    going_to_example_number: args.goingToExampleNumber,
    time_spent_on_example_ms: args.timeSpentOnExampleMs,
    automatic_transition_time_ms: args.automaticTransitionTimeMs,
    screen: 'first_time_lister_education',
  }

  return {
    event: 'user.first_time_lister_education_example_switch',
    extra,
  }
}

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs): TrackingEvent => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}
